module.exports = __webpack_public_path__ + "static/img/ic_logo.9486960d.png";